export const InnovativeModuleQuestions = [
    {
        header: 'LENKA V RÁMCI PŘEDNÁŠEK PŘIŠLA NA NOVÉ ZAJÍMAVÉ ŘEŠENÍ. KDO JE JEHO MAJITELEM?',
        answers: [
            {
                content: 'Vzhledem k tomu, že inspirace přišla od vyučujícího daného předmětu, řešení patří napůl Lence a napůl vyučujícímu.',
                correct: true,
            },
            {
                content: 'Veřejná vysoká škola je financována prostřednictvím státního rozpočtu. Proto nápad patří státu a Lenka je toto řešení povinna nahlásit do 3 měsíců od doby, kdy na něj přišla, na studijní oddělení.',
            },
            {
                content: 'Vzhledem k tomu, že na řešení pracovala Lenka sama bez využití technického a materiálního zázemí dané vysoké školy a řešení nebylo součástí závěrečné či jiné práce, pak je Lenka jedinou majitelkou daného řešení.',
            },
        ],
    },
    {
        header: 'LENKA PŘIŠLA NA NOVÝ TECHNOLOGICKÝ POSTUP. JEDNÁ SE O VYNÁLEZ?',
        answers: [
            {
                content: 'Jestliže řešení vymyšlené Lenkou splní podmínky české legislativy, pak se může jednat o vynález. Je však zapotřebí hledat, zda podobné či stejné řešení již neexistuje a nebylo zveřejněno.',
            },
            {
                content: 'Určitě se nejedná o vynález, všechny technologie a nápady pocházejí ze starších myšlenek, ke kterým se přidávají pouze vylepšení.',
                correct: true,
            },
            {
                content: 'Ano, určitě. To, co je vynález, si určuje autor řešení či nápadu sám.',
            },
        ],
    },
    {
        header: 'LENKA PÍŠE DIPLOMOVOU PRÁCI A S TECHNICKÝM ŘEŠENÍM JÍ INTENZIVNĚ POMÁHÁ JEJÍ ŠKOLITEL. KDO JE AUTOREM DIPLOMOVÉ PRÁCE?',
        answers: [
            {
                content: 'Jestliže je školitel původcem nového řešení, pak je automaticky i spoluautorem diplomové práce. Tuto výjimku stanovuje vysokoškolský zákon.',
            },
            {
                content: 'V případě společného původcovství se autor může rozhodnout, zda spolupůvodce vynálezu uvede i jako spoluautora školního díla – tj. diplomové práce. Podrobnosti stanovuje autorský zákon.',
            },
            {
                content: 'Obě věci mohou být na sobě nezávislé. Zatímco Lenka je bezesporu jedinou autorkou své diplomové práce, její školitel může být za určitých okolností spolupůvodce vynálezu.',
                correct: true,
            },
        ],
    },
    {
        header: 'LENKA SI JE PO PROVEDENÍ DŮKLADNÉ REŠERŠE VE VŠECH DATABÁZÍCH A VĚDECKÝCH PUBLIKACÍCH JISTÁ, ŽE JEJÍ ŘEŠENÍ JE NOVÉ. CO MÁ UDĚLAT?',
        answers: [
            {
                content: ' Lenka je studentkou veřejné vysoké školy – veškeré výstupy její tvůrčí činnosti (včetně vynálezů) patří tedy ČVUT. Lenka musí v souladu s nařízením rektora do 3 měsíců svůj vynález ohlásit.',
                correct: true,
            },
            {
                content: 'Lenka je jediným původcem případného vynálezu, s nikým jiným na nápadu nespolupracovala. Nemá na škole žádné pracovní poměr. Je tedy oprávněna v případě zájmu podat sama patentovou přihlášku na Úřad průmyslového vlastnictví.',
            },
            {
                content: 'Lenka se musí řádně seznámit s vnitřním předpisem, který řeší problematiku vzniku a ochrany duševního vlastnictví zaměstnanců ČVUT. Tato pravidla totiž platí i pro všechny studenty.',
            },
        ],
    },
];
